import styled from "styled-components";

export const NavTabs = styled.ul`
    margin-bottom: 1rem;
    display: flex;
    gap: 1rem;
    flex-wrap: wrap;
    
    &.titles {
        font-size: 1.125rem;
        font-weight: bold;
    }
`

export const NavItem = styled.li`
    border: 1px solid #dee2e6;
    border-radius: 8px;
    cursor: pointer;

    & > * {
        border: none;
        background-color: transparent;
        cursor: pointer;
        
        display: grid;
        width: 100%;
        height: 100%;
        place-items: center;
        padding: 0.5rem 1rem;
    }

    &.active {
        background-color: var(--bs-primary);

        &, a, * {
            color: white;
        }
    }
`